<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-list"></i>
          <strong>
            {{title}}
            <b-spinner v-if="loading" class="float-right" small/>
          </strong>
        </div>
        <div>
          <stock-list :column_display="column_display"
                      :columns="columns"
                      :filterable="filterable"
                      :headings="headings"
                      :url="url"
                      @on-loading="loading=$event"/>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  import StockList from '../ServerFilterableTable'

  export default {
    name: "DocumentAreaStock",
    components: {
      StockList
    },
    data () {
      return {
        title: "Listado de stock",
        loading: false,
        column_display: {
          lot__number: '',
          lot__document__company__name: '',
          lot__document__company__company_number: '',
          stock_area__name: '',
          product__fruit__family__name: 'not_desktop',
          product__fruit__name: 'not_desktop',
          product__code: '',
          container__name: '',
          product__name: '',
          quantity: '',
          net_kilograms: '',
        },
        columns: [
          "stock_area__name",
          "lot__document__company__company_number",
          "lot__document__company__name",
          "product__fruit__family__name",
          "product__fruit__name",
          "product__code",
          "product__name",
          "lot__number",
          "container__name",
          "quantity",
          "net_kilograms",
        ],
        filterable: [
          "lot__number",
          "lot__document__company__name",
          "lot__document__company__company_number",
          "stock_area__name",
          "product__fruit__family__name",
          "product__fruit__name",
          "container__name",
          "product__name",
          "product__code",
        ],
        headings: {
          container__name: "Recipiente",
          lot__number: "Lote",
          lot__document__company__name: "Empresa",
          lot__document__company__company_number: "Rut",
          stock_area__name: "Area",
          product__fruit__family__name: "Familia",
          product__fruit__name: "Fruta",
          product__code: "Código",
          product__name: "Producto",
          quantity: "Cantidad",
          net_kilograms: "KN",
        },
        // listColumns: {
        //   document_type: [
        //     {id: 0, text: 'Guia de despacho'},
        //     {id: 1, text: 'Factura'},
        //     {id: 2, text: 'Otro'},
        //   ]
        // },
      }
    },
    computed:{
      stock_area_filter_constructor() {
        let filter = this.$route.params;
        filter = !_.isEmpty(filter) ? filter.process_type_complete.stockarea_set.map(e => e.id).join("|stock_area=") : "";
        return 'stock_area='+filter;
      },
      url() {
        return '/bagno/document-area-stock/?'
      }
    },
    methods: {
      rowClassCallback() {
        return 'table-warning'
      },
    }
  }
</script>

<style scoped>

</style>
